import { FormControl, FormGroup } from '@angular/forms';
import { SearchModelV2 } from '../search-model-v2';

/**
 * Search model for the user permissions listing.
 *
 * Converted from the legacy SearchModel. The raw SQL it used to carry:
 *
 *   query:  (q) => q
 *     ? `subject.principal_id ILIKE '%q%' AND hdr.status!='DELETED'`
 *     : `hdr.status!='DELETED'`
 *   table:  'bl_applet_login_subject_link'
 *   joins:  LEFT JOIN app_login_principal subject ON subject.subject_guid = hdr.app_login_guid
 *   queryCallbacks: { rank: r => `hdr.rank='r'` }
 *
 * The component maps those onto criteria the applet-login-subject-link endpoint
 * understands: the keyword onto `search_word` (AppletLoginSubjectLinkUow joins
 * app_login_principal itself and ILIKEs principal_id, principal_value and rank)
 * and rank onto `rank`.
 */
export const UserPermSearchModel: SearchModelV2 = {
    label: {
        rank: 'Rank'
    },
    dataType: {
        rank: ['select', ['OWNER', 'ADMIN', 'MEMBER', 'GUEST']]
    },

    form: new FormGroup({
        rank: new FormControl()
    }),

    options: {
        rank: {}
    }
}
